
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    btn: String,
    nameFluxo: String,
  },
})
export default class HeaderFluxo extends Vue {
  ORG_DATA: any = JSON.parse(
    sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
  );
  LOGO: any = this.ORG_DATA.CONFIGURATIONS.LOGO_IMAGE;

  buttonClickEvent() {
    this.$emit("buttonCallBack");
  }
}
